import ColorfulSeparator from '../../components/colorful-separator';
import StartingGame from './starting-game';
import Results from './results';
import useReduxState from '@hooks/useReduxState';
import styles from './game.module.scss';
import { IJackpotCountdowns } from '@api/types/jackpot';
import useJackpotRoom from '@hooks/useJackpotRoom';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import { TGameStatus } from '@api/types/generalGame';

export interface IGameCountdowns {
    countdowns: IJackpotCountdowns;
}

const Game = ({ COLORS }: { COLORS: string[] }): JSX.Element => {
    const [{ rooms }] = useReduxState((state) => state.jackpot);
    const { currentRoom } = useJackpotRoom();
    const game = rooms[currentRoom].current_game;
    const [status, setStatus] = useState<TGameStatus>('active');

    useEffect(() => {
        if (game.game_metadata.status === 'finished') {
            setStatus('finished');
        }
    }, [game]);

    // eslint-disable-next-line no-unused-vars
    const [_forceUpdate, setForceUpdate] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setForceUpdate(new Date().getTime());
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    });

    return (
        <>
            <div
                className={styles['container-border']}
                style={
                    game.players_joined > 0
                        ? {
                              borderRadius: '16px 16px 0px 0px',
                              borderBottom: 'none',
                          }
                        : {
                              borderRadius: '16px 16px 16px 16px',
                              borderBottom:
                                  '1px solid fns.getColor("light-dark")',
                          }
                }
            >
                <div
                    className={cn(styles.game_info, {
                        [styles.start]:
                            status === 'finished' &&
                            Math.floor(Date.now() / 1000) -
                                game.game_metadata.ended_at >=
                                25,
                        [styles.end]:
                            status === 'finished' &&
                            Math.floor(Date.now() / 1000) -
                                game.game_metadata.ended_at <
                                25,
                    })}
                    style={
                        status === 'finished' &&
                        Math.floor(Date.now() / 1000) -
                            game.game_metadata.ended_at <
                            25
                            ? {
                                  top: '-100%',
                              }
                            : {
                                  top: '0%',
                              }
                    }
                >
                    <StartingGame />
                    <Results />
                </div>
            </div>
            {game.players.length > 1 && (
                <ColorfulSeparator
                    className={styles.separatorLine}
                    players={game.players}
                    stakes={game.stakes}
                    total_stakes={game.bank}
                    gameUid={game.uid}
                    isCurrent={true}
                    COLORS={COLORS}
                />
            )}
        </>
    );
};
export default Game;
